import useStore from "stores/index";
import { User, userDisplayText } from "../../utils/userUtils";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import { getClassroomStore } from "stores/classroomStore";
import Tooltip from "rc-tooltip";
import React, { FC } from "react";
import { default as IconPinClass } from "assets/IconPinClass.svg";
import { Flex } from "@chakra-ui/react";

interface Props {
	user: User;
	actionsJsx?: React.ReactNode;
}

export const StudentTileHeader: FC<Props> = (props) => {
	const displayName = userDisplayText(props.user);

	const selectedClassroomStore = useSelectedClassroomStore();
	const pinned = selectedClassroomStore.findStudent(props.user.username)?.pinned ?? false;

	const toggleStudentPin = () => {
		// eslint-disable-next-line
		const teacherStableIdV1 = getClassroomStore(useStore.getState()).getTeacherStableIdV1() as string;
		void selectedClassroomStore.toggleStudentPin(teacherStableIdV1, props.user.username);
	};

	return (
		<div className="StudentTileHeader">
			<Tooltip
				placement="top"
				trigger={["hover"]}
				destroyTooltipOnHide={true}
				overlayClassName="Tooltip"
				overlay={<span>{pinned ? "Unpin student" : "Pin student"}</span>}
			>
				<div className="Pin_button" onClick={toggleStudentPin} data-testid="pin-button" data-test-active={pinned}>
					<div className={pinned ? "Pin_active" : "Pin"}>
						<IconPinClass />
					</div>
				</div>
			</Tooltip>
			<div className="StudentTileHeader_title">{displayName}</div>
			{props.actionsJsx && (
				<Flex alignItems={"center"} gap={"6px"}>
					{props.actionsJsx}
				</Flex>
			)}
		</div>
	);
};
